import { WbTextField } from '@agilelab/plugin-wb-platform';
import { useFormExtraConfigContext } from '../../../contexts/FormExtraConfigContext';
import { extractCustomProperties, isHidden } from '../../utils';
import { RegexPickerProps } from './schema';

export const RegexPicker = (props: RegexPickerProps) => {
  const {
    onChange,
    schema: {
      title = 'RegExPicker',
      description = 'Collect and validate data with a regular expression',
    },
    required,
    rawErrors,
    formData,
    idSchema,
    placeholder,
    uiSchema,
  } = props;
  const userSpecifiedPlaceholder = uiSchema['ui:placeholder'] ?? placeholder;
  const customProps = extractCustomProperties(uiSchema);

  const { debounceMs } = useFormExtraConfigContext();

  return (
    <WbTextField
      id={idSchema?.$id}
      style={{ display: isHidden(uiSchema) ? 'none' : undefined }}
      label={title}
      placeholder={userSpecifiedPlaceholder}
      helperText={description}
      required={required}
      value={formData ?? ''}
      debounceMs={debounceMs}
      onChange={({ target: { value } }) => onChange(value)}
      error={rawErrors?.length > 0}
      {...customProps}
    />
  );
};
